import Chess960Svg from '@/assets/icons/960.svg?component';
import Chess960SmallSvg from '@/assets/icons/960-small.svg?component';

export default {
  name: 'IconChess960',
  components: { Chess960Svg, Chess960SmallSvg },
  props: {
    color: { type: String, default: 'rgb(0,0,0)' },
    size: { type: String, default: '1em' },
    width: { type: String, default: null },
    height: { type: String, default: null },
    tooltipEnabled: { type: Boolean, default: true },
  },
  computed: {
    sizeValue() {
      const parsed = Number.parseFloat(String(this.size).replace(',', '.'));
      return Number.isFinite(parsed) ? parsed : null;
    },
    isSmallSize() {
      return this.sizeValue !== null && this.sizeValue <= 14;
    },
    svgComponent() {
      return this.isSmallSize ? 'Chess960SmallSvg' : 'Chess960Svg';
    },
    svgStyle() {
      return {
        height: this.height || this.size,
        width: this.width || 'auto',
        color: this.color,
        display: 'block',
      };
    },
    tooltipOptions() {
      return {
        value: this.$t('chessVariants.chess960Long'),
        class: 'tt-sm',
        disabled: !this.tooltipEnabled,
      };
    },
  },
};
